<script lang="ts">
  import { onMount } from "svelte"
  import { appStore } from "$app/store.svelte"

  function count(status: string): number {
    return appStore.goals.filter((g) => g.status === status).length
  }

  let mounted = $state(false)
  onMount(() => (mounted = true))
</script>

{#if mounted}
  {@const items =
    appStore.page === "assignee" ? appStore.tasks : appStore.goals}
  <div class="grid grid-cols-4 gap-2 px-2 md:px-0">
    <div class="flex flex-row items-center whitespace-nowrap">
      <div class="flex-none h-4 w-4 rounded-full bg-on_track"></div>
      <p class="text-sm text-gray-900 ml-1">
        {items.filter((g) => g.status === "on_track").length} on track
      </p>
    </div>
    <div class="flex flex-row items-center whitespace-nowrap">
      <div class="flex-none h-4 w-4 rounded-full bg-at_risk"></div>
      <p class="text-sm text-gray-900 ml-1">
        {items.filter((g) => g.status === "at_risk").length} at risk
      </p>
    </div>
    <div class="flex flex-row items-center whitespace-nowrap">
      <div class="flex-none h-4 w-4 rounded-full bg-critical"></div>
      <p class="text-sm text-gray-900 ml-1">
        {items.filter((g) => g.status === "critical").length} critical
      </p>
    </div>
    <div class="flex flex-row items-center whitespace-nowrap">
      <div class="flex-none h-4 w-4 rounded-full bg-complete"></div>
      <p class="text-sm text-gray-900 ml-1">
        {items.filter((g) => g.status === "complete").length} complete
      </p>
    </div>
  </div>
{/if}
